// extracted by mini-css-extract-plugin
export default {"action-btn":"Health--action-btn--4Eii7","actionBtn":"Health--action-btn--4Eii7"};